import { render, staticRenderFns } from "./ProfessionalInteractionsReport.vue?vue&type=template&id=387ee1e0&scoped=true&"
import script from "./ProfessionalInteractionsReport.vue?vue&type=script&lang=js&"
export * from "./ProfessionalInteractionsReport.vue?vue&type=script&lang=js&"
import style0 from "./ProfessionalInteractionsReport.vue?vue&type=style&index=0&id=387ee1e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387ee1e0",
  null
  
)

export default component.exports